module.exports = __webpack_public_path__ + "static/media/oem4.137ff3fa.JPG";